import type { BadgeVariant } from '@wearenotch/ui-react';
import { Category, InterfaceType } from '../types';

export const categoryColor: Record<Category, string> = {
  Transparency: '#d4691c',
  Control: '#0d3272',
  'Error Handling': '#e0472c',
  Onboarding: '#7a8716',
  Conversation: '#9a3fd4',
};

export const categorySlug: Record<Category, string> = {
  Transparency: 'transparency',
  Control: 'control',
  'Error Handling': 'error-handling',
  Onboarding: 'onboarding',
  Conversation: 'conversation',
};

export const slugToCategory: Record<string, Category> = {
  transparency: 'Transparency',
  control: 'Control',
  'error-handling': 'Error Handling',
  onboarding: 'Onboarding',
  conversation: 'Conversation',
};

export const categoryBadgeVariant: Record<Category, BadgeVariant> = {
  Transparency: 'info',
  Control: 'primary',
  'Error Handling': 'error',
  Onboarding: 'warning',
  Conversation: 'success',
};

export const ifTypeBadgeVariant: Record<InterfaceType, BadgeVariant> = {
  'Chat UI':    'info',
  'Voice UI':   'primary',
  'Agentic UI': 'warning',
};

export const categoryDescriptions: Record<Category, string> = {
  Transparency:
    'Patterns that help users understand what the AI is doing, why, and how confident it is.',
  Control:
    'Patterns that ensure users remain in control of consequential agent actions.',
  'Error Handling':
    'Patterns for handling failures gracefully and keeping users informed.',
  Onboarding:
    'Patterns for introducing agent capabilities without overwhelming new users.',
  Conversation:
    'Patterns for maintaining coherent, recoverable, and contextual dialogues.',
};
